export default __webpack_public_path__ + "static/media/dots-menu.8b056dba.svg";